function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.3889 5L15.1667 5.77778H17.8889V7.33333H7V5.77778H9.72222L10.5 5H14.3889ZM12.4443 12.4588L14.0932 10.81L15.1899 11.9066L13.541 13.5555L15.1899 15.2044L14.0932 16.3011L12.4443 14.6522L10.7955 16.3011L9.69879 15.2044L11.3477 13.5555L9.69101 11.9066L10.7877 10.81L12.4443 12.4588ZM7.7778 17.4444C7.7778 18.3 8.4778 19 9.33336 19H15.5556C16.4111 19 17.1111 18.3 17.1111 17.4444V8.1111H7.7778V17.4444ZM15.5556 9.66665H9.3334V17.4444H15.5556V9.66665Z",
  fill: "#93A7BE"
});

var SvgIconRemove24 = function SvgIconRemove24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRemove24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconRemove24.f5ec2c03.svg";
export { ForwardRef as ReactComponent };